import { SimpleProduct } from '../../repositories/product/response/ProductSimpleListResponse'
import { number, string } from '../../util/Entity'

const SimpleProductListEntity = ({ productId, name }: SimpleProduct) => ({
  productId: number(productId),
  name: string(name),
})

export default SimpleProductListEntity
